import type { ITrip } from "~~/types/liveTracking/3pl.interface";
import { useThreeeplStore } from "../../stores/useThreeplStore";
import { LOCAL_STORAGE_KEY } from "~~/constant/tracking.constant";

type TModalConfig = {
    title?: string
    description?: string
    closeBtn?: boolean
}

const modalBbmConfig = ref<TModalConfig>({
    title: '',
    description: '',
    closeBtn: true,
})

const isModalOpen = ref<boolean>(false);
const isApiError = ref<boolean>(false)
const isModalDateFilter = ref<boolean>(false);
const isModalTrackingFilter = ref<boolean>(false);

export const useThreepl = (headerRef?: Ref<HTMLElement | null>) => {
    const mainHeight = ref("0px");
    const { dateFilter, fetchDetailTrip, fetchTrip3pl, detailTripId } = useThreeeplStore()
    const { member } = useMember();
    const { setLastUpdate, showBadgeWithReset, lastUpdate } = useUpdateBadge()

    const handleSelectTrip = async (trip: ITrip) => {
        const res = await fetchDetailTrip(trip.id)

        if (!res.success) {
            if (res.error?.includes('TRIP_3PL_CHANGED_TO_INTERNAL')) {
                isModalOpen.value = true
                modalBbmConfig.value = {
                    title: 'Trip Tidak Tersedia',
                    description: 'Trip yang Anda pilih telah berubah status menjadi trip internal',
                    closeBtn: true
                }
            }
        }
    };

    const calculateHeight = () => {
        const contentBody = document.querySelector(".content-body") as HTMLElement;

        if (headerRef?.value && contentBody) {
            const viewportHeight = window.innerHeight;
            const bodyHeight = contentBody.getBoundingClientRect();
            const distanceFromTop = bodyHeight.top;
            const marginTop = 16;
            const marginBottom = 30;
            const finalHeight = viewportHeight - distanceFromTop - marginTop - marginBottom;
            mainHeight.value = `${finalHeight}px`;
        }
    };

    const handleOpenTrackingFilter = () => {
        isModalTrackingFilter.value = true;
    }

    const handleOpenDateFilter = () => {
        isModalDateFilter.value = true;
    }

    const handleSelectDateCalendar = (selectedDate: { start: Date, end: Date }) => {
        dateFilter.value = selectedDate;
        isModalDateFilter.value = false;
    }

    const handleUpdateStatus = async () => {

        const trip =
            await fetchTrip3pl(
                { storeCode: member.value?.storeCode },
                true
            )

        if (!trip.success) {
            return
        }

        if (detailTripId.value) {

            const detail =
                await fetchDetailTrip(detailTripId.value)

            if (!detail.success) {
                return
            }

        }

        lastUpdate.value =
            setLastUpdate(LOCAL_STORAGE_KEY.ThreePL)

        showBadgeWithReset()
    }

    return {
        handleSelectTrip,
        calculateHeight,
        mainHeight,
        isModalOpen,
        modalBbmConfig,
        handleOpenDateFilter,
        isModalDateFilter,
        handleOpenTrackingFilter,
        isModalTrackingFilter,
        handleSelectDateCalendar,
        handleUpdateStatus,
        isApiError
    }
}